module.exports = __webpack_public_path__ + "static/media/dotted1.8788d8f7.svg";